export const getFromLocalStorage = <T>(key: string): T | undefined => {
  const cachedData = localStorage.getItem(key);
  if (cachedData) {
    try {
      return JSON.parse(cachedData);
    } catch {
      return undefined;
    }
  }
  return undefined;
};

export const setToLocalStorage = <T>(key: string, item: T | undefined) => {
  if (item) {
    localStorage.setItem(key, JSON.stringify(item));
  } else {
    localStorage.removeItem(key);
  }
};
